import { TripContext } from 'contexts';
import React, { FC, Fragment, useContext } from 'react';
import { CatchWeight, ReconcileReason, RefusalReason } from 'services/types';
import './reconcile-reason.scss';

type Props = {
    catchWeightId: number
};

export const ReconcileReasonCatchWeight: FC<Props> = ({ catchWeightId }) => {

    const tripContext = useContext(TripContext)

    const catchWeight: CatchWeight = tripContext.catchWeights.find(weight => weight.id == catchWeightId) ?? {} as CatchWeight
    const reconcileReason: ReconcileReason = tripContext.reconcileReasons.find(reason => reason.id === catchWeight.reconcileReasonId) ?? {} as ReconcileReason
    const refusalReason: RefusalReason = tripContext.refusalReasons.find(reason => reason.reconcileReasonId === catchWeight.reconcileReasonId) ?? {} as RefusalReason

    return (
        <Fragment>
            < div className={'reconcile-reason-card-row'}>
                <div className={'reconcile-reason-card-text'} style={{ width: '45%' }}>
                    <div>{reconcileReason.description} </div>
                    {reconcileReason.isRefusalReasonRequired &&
                        <div>{refusalReason.description ?? '-'} </div>
                    }
                </div>
                <div className={'reconcile-reason-card-text'} style={{ width: '40%' }}>
                    <div>{catchWeight.returnSticker ?? '-'}</div>
                    <div>{catchWeight.refusalComment && catchWeight.refusalComment}</div>
                </div>
                <div className={'reconcile-reason-card-text'} style={{ width: '15%' }}>{catchWeight.adjustedWeight == 0 ? catchWeight.shippedWeight : catchWeight.adjustedWeight} </div>
            </div>
        </Fragment >
    )
}
